app.service('accountReceiverView', function (console, validate, account, modal, loading, accountConfig) {
	var $self;
	var config;

	function setElements() {
		$self = $('#receiver-data-box');
		config = accountConfig.getData();
	}
	function setEvents() {
		$self.on('click', '.js-receiver-cancel', function () {
			cancel($(this).data('id'));
		}).on('click', '.js-receiver-add', function () {
			load();
		}).on('click', '.js-receiver-edit', function () {
			load($(this).data('id'));
		}).on('click', '.js-receiver-remove', function () {
			confirmDeleteAddress($(this).data('id'));
		}).on('click', '.js-receiver-set-default', function () {
			setDefaultDeliveryAddress($(this).data('id'));
		});
	}
	function cancel(addressId = 0) {
		let $div = $('#receiver-data-' + addressId);
		$div.empty();
	}
	function load(addressId = 0) {
		let data = {};
		if (addressId) {
			data.receiverDataId = addressId;
			console.log('ŁADOWANIE ADRESU ODBIORCY - ' + addressId);
		} else {
			console.log('ŁADOWANIE NOWEGO ADRESU DOSTAWY');
		}
		loading.start();
		$.ajax({
			url: 'customer-receiver-data-edit.ltr',
			cache: false,
			data: data,
			success: function (content) {
				loading.stop();
				generate(addressId, content);
			},
			error: function () {
				loading.stop();
				loadError();
			}
		});
	}
	function loadError() {
		console.log('ŁADOWANIE ADRESU ODBIORCY - ERROR');
	}
	function generate(addressId, content) {
		let $div = $('#receiver-data-' + addressId);
		$div.html(content);
		let $form = $div.find('form');

		validate.task('receiver', {
			$form,
			send: function () { 
				send($form, addressId);
			}
		});
	}
	
	function send($form, addressId) {
		if (account.isFrontUserLogged()) {
			loading.start();
			$form.ajaxSubmit({
				success: function (html) {
					loading.stop();
					sendSuccess(addressId, html);
				},
				error: function () {
					loading.stop();
				}
			});
		}
	}
	function sendSuccess(addressId, html) {
		generate(addressId, html);
		if ($(html).filter('.success').length) {		//mamy powodzenie
			loading.reload();
		}

	}
	function confirmDeleteAddress(addressId) {
		console.log('POTWIERDZENIE USUNIĘCIA ADRESU - ' + addressId);
		modal.generate({
			header: 'Czy na pewno chcesz usunąć wskazane dane odbiorcy?',
			id: 'delete-address',
			buttons: [
				{
					text: 'Tak',
					cssClass: 'button-remove-address',
					click: function () {
						modal.close();
						deleteAddress(addressId);
					}
				},
				{
					text: 'Anuluj',
					cssClass: 'button-cancel',
					click: function () {
						modal.close();
					}
				}
			]
		});
	}
	function deleteAddress(addressId) {
		loading.start();
		$.ajax({
			url: '/customer-remove-receiver-data.ltr',
			type: 'POST',
			cache: false,
			data: {
				receiverDataId: addressId
			},
			success: function (html) {
				loading.reload();
			},
			error: function () {
				modal.alert('Błąd usuwania adresu. Spróbuj ponownie później', function () {
					loading.reload();
				});
			}
		});
	}
	function setDefaultDeliveryAddress(addressId) {
		loading.start();
		$.ajax({
			url: '/customer-set-default-receiver-data.ltr',
			type: 'POST',
			cache: false,
			data: {
				receiverDataId: addressId
			},
			success: function (html) {
				loading.reload();
			},
			error: function () {
				modal.alert('Błąd ustawiania danych domyślnych. Spróbuj ponownie później', function () {
					loading.reload();
				});
			}
		});
	}
	function init() {
		setElements();
		setEvents();
	}
	return {
		init: init
	};
});
